"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var helpers_1 = require("../../utils/component/helpers");
function getImageUrl(native) {
    var imageUrl;
    if (native.image && native.image.url) {
        // v3
        imageUrl = native.image.url;
    }
    else if (helpers_1.isNonEmptyArray(native.mainMedia) && native.mainMedia[0].url) {
        // v2
        imageUrl = native.mainMedia[0].url;
    }
    else {
        return;
    }
    return helpers_1.escape(imageUrl);
}
var BackgroundMedia = function (_a) {
    var native = _a.native, className = _a.className, style = _a.style;
    return (React.createElement("div", { className: className, style: __assign(__assign({}, style), { backgroundImage: "url(\"" + (getImageUrl(native) || '') + "\")" }) }));
};
exports.default = BackgroundMedia;
